import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/review',
    name: 'review',
    component: () => import('@/views/ReviewPage.vue'),
  },
  {
    path: '/poll',
    name: 'poll',
    component: () => import('@/views/PollPage.vue'),
  },
  {
    path: '/gift',
    name: 'gift',
    component: () => import('@/views/GiftPage.vue'),
  },
  {
    path: '/panacea',
    component: () => import('@/views/PanaceaPage.vue'),
  },
  {
    path: '/page-not-found',
    component: () => import('@/views/PageNotFound.vue'),
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/page-not-found',
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
